module.exports = __webpack_public_path__ + "img/cute_natural_doodle_12.58609bfc.png";